import { useTranslation } from 'react-i18next';

import Icon from '~/components/icon';
import { type AllSportsItems } from '~/interfaces/HeaderFooterNavV2';

import styles from './HeaderAllSports.module.css';

interface HeaderAllSportsProps {
  items: AllSportsItems;
  onClose: () => void;
}

export const HeaderAllSports = (props: HeaderAllSportsProps) => {
  const { items } = props;
  const { t } = useTranslation('label');

  const { allLinks, featuredLinks } = items;

  return (
    <div className={styles.container}>
			<div className={styles.content}>
				<div className={styles.headerWrapper}>
					<h2 className={styles.sectionHeader}>{t('SPORTS ODDS')}</h2>

					<button className={styles.closeIcon} onClick={props.onClose}>
						<Icon height={16} icon="Close" width={16} />
					</button>
				</div>

				<div className={styles.linkWrapper}>
					<div className={styles.featuredLinks}>
						{featuredLinks.map((featuredGroup, index) =>
            <section key={`featuredLinks-${index}`}>
								<ul>
									{featuredGroup.links.map(({ link, name }) =>
                <li key={`featuredLinks-${index}-${name}`}>
											<a className={styles.link} href={link}>
												{name}
											</a>
										</li>
                )}
								</ul>
							</section>
            )}
					</div>

					<div className={styles.allLinks}>
						{allLinks.map((linkGroup, index) =>
            <section key={`allLinks-${index}`}>
								<div className={styles.linkGroupWrapper}>
									<Icon
                  className={styles.icon}
                  height={14}
                  icon={linkGroup.icon}
                  width={14} />

									<a className={styles.subHeader} href={linkGroup.link}>
										{linkGroup.name}
									</a>
								</div>
								<ul>
									{linkGroup.subLinks.map(({ link, name }) =>
                <li key={`allLinks-${index}-${name}`}>
											<a className={styles.subLink} href={link}>
												{name}
											</a>
										</li>
                )}
								</ul>
							</section>
            )}
					</div>
				</div>
			</div>
		</div>);

};